<template>
  <b-container fluid class="padding-none">
    <ui-header />
    <b-row class="px-md-2 pr-md-4 pt-4 row-padding">
      <b-col md="6">
        <div class="d-none d-md-block">
          <side-image />
        </div>
      </b-col>
      <b-col md="6" class="px-6 px-md-2 bottom-policy">
        <router-view />
        <bottom-policies class="mt-3" :logoutButton="false" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import UiHeader from "../../components/ui/app-header";
import SideImage from "../../components/ui/side-image";
import BottomPolicies from "../../components/ui/bottom-policies";

export default {
  components: {
    BottomPolicies,
    UiHeader,
    SideImage
  },
  name: "layouts-passthrough"
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .row-padding {
    margin: 0 1rem 1rem 1rem;
  }
  .fixed-row-bottom {
    margin-top: 1rem;
  }
}
@media only screen and (min-width: 600px) {
  .row-padding {
    margin: 0 3rem 3rem 3rem;
  }
}
.bottom-policy {
  padding-bottom: 59px;
}
</style>
